/**
 * Saved wanted posters: legacy field `isMainCollage` is now `isPrivateCollage`
 * (this collage participates in computer match). One primary collage may use computer
 * match, community match, or both.
 */
export function normalizeSavedPoster(p) {
  if (!p || typeof p !== 'object') return p;
  const { isMainCollage, ...rest } = p;
  const isPrivateCollage = !!(rest.isPrivateCollage ?? isMainCollage);
  return { ...rest, isPrivateCollage };
}

export function normalizeSavedPostersList(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map(normalizeSavedPoster);
}
